import { render, staticRenderFns } from "./LoadingModal.vue?vue&type=template&id=a630eca4&scoped=true&"
import script from "./LoadingModal.vue?vue&type=script&lang=js&"
export * from "./LoadingModal.vue?vue&type=script&lang=js&"
import style0 from "./LoadingModal.vue?vue&type=style&index=0&id=a630eca4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a630eca4",
  null
  
)

export default component.exports